import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditGraduationPage from '@/features/jobs/job-edit-graduation/JobEditGraduationPage';

export const jobEditGraduationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/formacao',
  component: JobEditGraduationPage,
});
